import 'babel-polyfill'

import cookies from './utilities/cookies'
import anchor from './utilities/anchor'
import cart from '../modules/Cart/Cart'
import cocktail from '../modules/Cocktail/cocktail'
import consent from '../modules/Consent/Consent'
import contacts from './contacts'
import countrySelector from '../modules/Country-Selector/Country-Selector'
import galleryRecipes from '../modules/Galleries/GalleryRecipes'
import galleryStory from '../modules/Galleries/GalleryStory'
import header from '../modules/header/header'
import jump from './utilities/jump'
import main from '../modules/Main/Main'
import modal from '../modules/Modal/Modal'
import product from '../modules/Product/Product'
import scroll from './utilities/scroll'
import share from '../modules/Share/Share'
import signUp from '../modules/Signup/Signup'
import stockists from './stockists'
import tile from '../modules/Tile/Tile'
import toggle from './utilities/toggle'

// Cookie consent dependent JS
consent.enable({
  callback(state) {
    const preferences = state.find(item => item.slug === 'preferences')
    const statistics = state.find(item => item.slug === 'statistics')
    const marketing = state.find(item => item.slug === 'marketing')

    // country selector (preferences)
    countrySelector.enable(preferences.consent)

    // signup (preferences)
    signUp.enable(preferences.consent)

    // modal (preferences)
    modal.enable(preferences.consent)

    // amazon marketing (marketing)
    cookies.amazon(marketing.consent)

    // facebook pixel (marketing)
    cookies.fb(marketing.consent)

    // google analytics (statistics and marketing)
    cookies.ga(statistics.consent && marketing.consent)

    // ometria (marketing)
    cookies.ometria(marketing.consent)

    // seedlip cookies (preferences)
    cookies.seedlip(preferences.consent)

    // shopify analytics (statistics and marketing)
    cookies.shopify(statistics.consent)

    // vwo analytics (statistics and marketing)
    cookies.vwo(statistics.consent)
  },
  consentItems: [
    {
      name: 'Preferences',
      purpose:
        'Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.',
    },
    {
      name: 'Statistics',
      purpose:
        'Statistic cookies from services such as Shopify Analytics and Google Analytics to help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.',
    },
    {
      name: 'Marketing',
      purpose:
        'Marketing cookies from services such as Facebook and Ometria are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.',
    },
  ],
})

window.addEventListener('scroll', () => main.enable())

scroll.enable()
stockists.enable()
cocktail.enable()
contacts.enable()
cart.enable()
product.enable()
anchor.enable()
tile.enable()
jump.enable()
galleryRecipes.enable()
galleryStory.enable()
header.enable()
share.enable()
toggle.enable()
